// === FILENAME: src/data/fixturesData.js ===
export const fixturesData = [
  {
    id: 1,
    homeTeam: "Villa del Dique",
    homeInitials: "VDQ",
    homeColor: "#3BA3EF",
    homeGoals: 3,
    awayTeam: "Dep. Mina Clavero",
    awayInitials: "DMC",
    awayColor: "#e74c3c",
    awayGoals: 1,
    date: "15 Mar 2025",
    competition: "Liga Regional",
    result: "win",
  },
  {
    id: 2,
    homeTeam: "Achiras FC",
    homeInitials: "ACH",
    homeColor: "#f39c12",
    homeGoals: 2,
    awayTeam: "Villa del Dique",
    awayInitials: "VDQ",
    awayColor: "#3BA3EF",
    awayGoals: 2,
    date: "08 Mar 2025",
    competition: "Liga Regional",
    result: "draw",
  },
  {
    id: 3,
    homeTeam: "Villa del Dique",
    homeInitials: "VDQ",
    homeColor: "#3BA3EF",
    homeGoals: 0,
    awayTeam: "Río Cuarto AC",
    awayInitials: "RCA",
    awayColor: "#2ecc71",
    awayGoals: 1,
    date: "01 Mar 2025",
    competition: "Copa Córdoba",
    result: "loss",
  },
];
